import { fetcher, postFetcher, putFetcher } from 'util/Api';

export const getHkdBookPolicy = async () => fetcher('/api/v1/hkd-books/policy');
export const updateHkdBookPolicy = async data => putFetcher('/api/v1/hkd-books/policy', data);
export const installDnTaxDefaults = async () => postFetcher('/api/v1/hkd-books/policy/install-dn-tax-defaults');
export const getPeriodPresets = async year =>
  fetcher('/api/v1/hkd-books/period-presets/', { params: { ...(year ? { year } : {}) } });

export const HkdBookPolicyAPI = {
  getHkdBookPolicy,
  updateHkdBookPolicy,
  installDnTaxDefaults,
  getPeriodPresets,
};
